import React from "react"
// import {
//   GraphScreen
// } from "../../screens"
// import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { createStackNavigator } from "@react-navigation/stack"
// import { translate } from "../../i18n";
// import { color } from "../../theme";

export type GraphNavigatorParamList = {
  'Graph.Graph': undefined
}

const Stack = createStackNavigator<GraphNavigatorParamList>()

export const GraphStack = {
  index: 0,
  routes: [
    { name: 'Graph.Stack', state: { index: 0, routes: [{ name: 'Graph.Graph' }] } }
  ]
};

export const GraphNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        cardStyle: { flex: 1 },
        headerShown: false,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerTitleContainerStyle: { marginLeft: 0 }
      }}
      // initialRouteName="Graph.Graph"
    >
      {/* <Stack.Screen name="Graph.Graph" component={GraphScreen} */}
      {/*  options={{ */}
      {/*    title: 'Graph', */}
      {/*    headerTitle: translate('graphScreen.header'), */}
      {/*    headerShown: true, */}
      {/*    headerShadowVisible: false, */}
      {/*    headerStyle: { backgroundColor: color.primary, borderBottomWidth: 0 }, */}
      {/*    headerTintColor: color.palette.white */}
      {/*  }} */}
      {/* /> */}
    </Stack.Navigator>
  )
}
